<template>
    <div class="contents">
        <div class="container-fluid">
            <FollowUpNavigation />
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    Edit Template Pesan
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <form @submit.prevent="updateTemplate">
                            <div class="form-group">
                                <label>Judul Template <span class="text-danger">*</span></label>
                                <input type="text" v-model="form.title" class="form-control" required />
                            </div>
                            <div class="form-group">
                                <label>Isi Pesan <span class="text-danger">*</span></label>
                                <CustomTextarea v-model="form.message" />
                                <small class="form-text text-muted">
                                    <i class="fas fa-info-circle"></i> 
                                    Variable yang tersedia: <code>{nama}</code>
                                </small>
                            </div>
                            <div class="form-group">
                                <label>Upload Media (Opsional)</label>
                                <input ref="file" type="file" @change="onFileChange" class="form-control" accept=".jpg,.jpeg,.png,.mp4,.mov" />
                                <div v-if="form.media_url" class="mt-2">
                                    <img v-if="isImage(form.media_url)" :src="form.media_url" alt="Preview" style="max-width: 200px; max-height: 200px; border-radius: 8px;" />
                                    <div v-else class="p-2 bg-light rounded">
                                        <i class="fas fa-file-video"></i> Media terpilih
                                    </div>
                                    <button type="button" @click="removeMedia" class="btn btn-sm btn-danger mt-2">
                                        <i class="fas fa-times"></i> Hapus Media
                                    </button>
                                </div>
                                <div v-else-if="file" class="mt-2">
                                    <small class="text-muted">
                                        <i class="fas fa-file"></i> File terpilih: {{ file.name }}
                                    </small>
                                </div>
                            </div>
                            <button type="submit" class="btn btn-primary" :disabled="isUploading">
                                <i class="fas fa-save"></i> {{ isUploading ? 'Menyimpan...' : 'Update Template' }}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomTextarea from "@/components/module/CustomTextarea.vue";
import FollowUpNavigation from "@/components/followup/Navigation.vue";

export default {
    components: {
        CustomTextarea,
        FollowUpNavigation
    },
    data() {
        return {
            templateId: null,
            form: {
                title: '',
                message: '',
                media_url: null
            },
            file: null,
            isUploading: false
        };
    },
    async mounted() {
        this.templateId = this.$route.query.id;
        if (this.templateId) {
            await this.loadTemplate();
        }
    },
    methods: {
        async loadTemplate() {
            try {
                const response = await this.$store.dispatch("followup/followup_template_one", this.templateId);
                const template = response.data.data.template;
                this.form = {
                    title: template.title,
                    message: template.message || '',
                    media_url: template.media_url
                };
            } catch (err) {
                this.$toast.error("Gagal memuat template");
            }
        },
        isImage(url) {
            if (!url) return false;
            return /\.(jpg|jpeg|png|gif)$/i.test(url);
        },
        onFileChange(e) {
            const file = e.target.files[0];
            if (file) {
                this.file = file;
            }
        },
        removeMedia() {
            this.file = null;
            this.form.media_url = null;
            if (this.$refs.file) {
                this.$refs.file.value = '';
            }
        },
        async updateTemplate() {
            this.isUploading = true;
            try {
                // Upload media if new file selected
                if (this.file) {
                    const formData = new FormData();
                    formData.append('file', this.file);
                    const response = await this.$store.dispatch('cdn_upload', formData);
                    if (response && response.data && response.data.data && response.data.data.url) {
                        this.form.media_url = response.data.data.url;
                    }
                }

                await this.$store.dispatch("followup/followup_template_update", {
                    id: this.templateId,
                    ...this.form
                });
                this.$toast.success("Template berhasil diupdate");
                this.$router.push({ name: 'FollowUpTemplate' });
            } catch (err) {
                this.$toast.error("Gagal mengupdate template");
            } finally {
                this.isUploading = false;
            }
        }
    }
};
</script>

